import { Box, SelectionList, Text } from '@dixa/lib-shared-habla';
import { MinimumIdentificationLevel } from 'lib-shared-legacy-types';

import { HookFormSelectionListSingle } from 'components/hookForm';
import { messengerSettingsFormFields } from 'components/settings/components/sections/dixaMessenger/views/settings/types';

import {
  AnonymousDetails,
  ClaimedDetails,
  VerifiedDetails,
  VerifiedSettings,
} from './components';

type AuthOption = {
  id: MinimumIdentificationLevel;
  name: string;
};

const items: AuthOption[] = [
  {
    id: 'ANONYMOUS',
    name: 'Allow anonymous users',
  },
  {
    id: 'CLAIMED',
    name: 'Allow users to claim their identity',
  },
  {
    id: 'VERIFIED',
    name: 'Programmatically authenticate the users',
  },
];

type Props = {
  /** The messenger id. */
  messengerId: string;
  /** Minimum identification level. */
  minimumIdentificationLevel?: MinimumIdentificationLevel;
};

/** Authentication messenger settings. */
export function Authentication({
  messengerId,
  minimumIdentificationLevel,
}: Props): JSX.Element {
  return (
    <>
      <Text.Heading variant="heading-3">Request user identity</Text.Heading>

      <Box margin="300 0 0 0">
        <HookFormSelectionListSingle
          label="Select a method"
          name={messengerSettingsFormFields.minimumIdentificationLevel}
          componentProps={{
            getItemTitleByValue(itemValue) {
              return items.find((item) => item.id === itemValue)?.name;
            },
          }}
        >
          {items.map((item) => (
            <SelectionList.Item key={item.id} value={item.id}>
              <Text.Paragraph>{item.name}</Text.Paragraph>
            </SelectionList.Item>
          ))}
        </HookFormSelectionListSingle>
      </Box>

      {minimumIdentificationLevel === 'ANONYMOUS' && <AnonymousDetails />}
      {minimumIdentificationLevel === 'CLAIMED' && <ClaimedDetails />}
      {minimumIdentificationLevel === 'VERIFIED' && <VerifiedDetails />}

      <VerifiedSettings messengerId={messengerId} />
    </>
  );
}
